import CryptoJS from 'crypto-js';
export const encriptar = (texto,clave)=>
{
    return CryptoJS.AES.encrypt(texto, clave).toString();
}
export const desEncriptar = (texto,clave)=>
{
    return CryptoJS.AES.decrypt(texto, clave).toString(CryptoJS.enc.Utf8);
}